var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticStyle: { height: "43px", width: "190px" },
      attrs: { loading: _vm.connectButtonLoading || _vm.connecting },
      on: { click: _vm.clickConnect }
    },
    [
      _vm.hover
        ? _c("v-xero-connect-blue-btn", {
            staticClass: "align-center cursor-pointer",
            on: {
              mouseover: function($event) {
                _vm.hover = true
              },
              mouseleave: function($event) {
                _vm.hover = false
              }
            }
          })
        : _c("v-xero-connect-white-btn", {
            staticClass: "align-center cursor-pointer",
            on: {
              mouseover: function($event) {
                _vm.hover = true
              },
              mouseleave: function($event) {
                _vm.hover = false
              }
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a5499d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a5499d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xero/XeroDirectConnectButton.vue
// module id = null
// module chunks = 